import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

/**
 * CartIdleWarningModal Component
 * Displays countdown warning before cart deletion due to inactivity
 */
const CartIdleWarningModal = ({ isOpen, onClose, countdownSeconds = 10 }) => {
  const [countdown, setCountdown] = useState(countdownSeconds);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(countdownSeconds);
      return;
    }

    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [isOpen, countdownSeconds]);

  const handleClose = () => {
    setCountdown(countdownSeconds);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <ModalHeader toggle={handleClose}>
        <i
          className="bx bx-alert-triangle"
          style={{
            fontSize: "24px",
            marginRight: "8px",
            color: "#ff7900",
          }}
        />
        Cart Idle Warning
      </ModalHeader>
      <ModalBody>
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "16px", marginBottom: "16px" }}>
            Your cart will be deleted in:
          </p>
          <div
            style={{
              fontSize: "48px",
              fontWeight: "700",
              color: "#ff7900",
              marginBottom: "16px",
              fontFamily: "monospace",
            }}
          >
            {countdown}s
          </div>
          <p style={{ fontSize: "14px", color: "#666" }}>
            Click or interact to keep your cart
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CartIdleWarningModal;
